export var TypeActionViewport;
(function (TypeActionViewport) {
    TypeActionViewport["CenterOn"] = "Viewport > CenterOn";
    TypeActionViewport["RequestClearCenter"] = "Viewport > RequestClearCenter";
    TypeActionViewport["ClearCenter"] = "Viewport > ClearCenter";
    TypeActionViewport["SmoothZoom"] = "Viewport > SmoothZoom";
    TypeActionViewport["ZoomIn"] = "Viewport > ZoomIn";
    TypeActionViewport["ZoomOut"] = "Viewport > ZoomOut";
})(TypeActionViewport || (TypeActionViewport = {}));
export var actionViewportCenterOn = function (position, zoom) {
    if (zoom === void 0) { zoom = false; }
    return ({
        position: position,
        type: TypeActionViewport.CenterOn,
        zoom: zoom,
    });
};
export var actionViewportRequestClearCenter = function () { return ({
    type: TypeActionViewport.RequestClearCenter,
}); };
export var actionViewportSmoothZoom = function () { return ({
    type: TypeActionViewport.SmoothZoom,
}); };
/**
 * Don't use. Only used from epicViewportRewriteBuildingCenter.
 * Instead use <code>actionViewportRequestClearCenter</code> action creator.
 */
export var actionViewportClearCenter = function () { return ({
    type: TypeActionViewport.ClearCenter,
}); };
export var actionViewportZoomIn = function () { return ({
    type: TypeActionViewport.ZoomIn,
}); };
export var actionViewportZoomOut = function () { return ({
    type: TypeActionViewport.ZoomOut,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/viewport/actionViewport.ts
// module id = 94
// module chunks = 3